var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p'),_c('h3',[_c('a-icon',{attrs:{"type":"check-circle"}}),_vm._v(" "+_vm._s(_vm.title))],1),_c('p')])}
var staticRenderFns = []

export { render, staticRenderFns }